<template>
  <div class="center">
    <a @click="facebookShare" style="margin:50px;display:block;">
      <i class="fa fa-facebook" aria-hidden="true"></i>
      <svg-icon style="width:40px;height:40px" icon-class="facebook-black"></svg-icon>
    </a>
  </div>
</template>

<script>
export default {
  name: "center",
  props: {
    detailsRes: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      text_com: '',
      ogUrl: '',
      ogType: '',
      ogTitle: '',
      ogDescription: '',
      ogImage: '',

    };
  },
  computed: {},
  watch: {
    detailsRes: {
      handler(newVal) {
        console.log('newVal',newVal)
        this.text_com = newVal.newsTitle
        this.ogUrl = window.location.href
        this.ogType = 'article'
        this.ogTitle = newVal.newsTitle
        this.ogDescription = this.cleanText(newVal.newsContent).substring(0, 200) + '...' 
        this.ogImage = this.resolveImageUrl(newVal.newsImage)
      },
      deep: true
    }
  },
  created() { 
    console.log('this.detailsRes',this.detailsRes)
  },
  methods: {
    resolveImageUrl(url) {
      return url && !/^http/.test(url) ? this.$imgUrl + url : url || '';
    },
    cleanText(html) {
      return html ? html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() : '';
    },
    facebookShare() {
      console.log(window.location.href)
      console.log('this.ogTitle',this.ogTitle)
      console.log('this.ogDescription',this.ogDescription)
      console.log('this.ogImage',this.ogImage)
      const url = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&title=${this.ogTitle}&description=${this.ogDescription}&picture=${this.ogImage}&quote=${this.ogDescription}`;
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/views/share/index.vue